module.exports = __webpack_public_path__ + "static/media/medford-small.dcdc8638.webp";